/**
 * Default body for creating the first dashboard shell on a model.
 */

export function buildEmptyDashboardBody(model: {
  id: number | string;
  time_properties?: {
    starting_period?: string;
    fy_start_month?: string;
    time_granularity?: string;
  };
}): {
  name: string;
  model_id: number;
  start_time: string;
  description: string;
} {
  const yr = new Date(model?.time_properties?.starting_period ?? Date.now())
    .getUTCFullYear()
    .toString();
  const fiscalStart = `${model?.time_properties?.fy_start_month ?? 'Jan'}-${yr.slice(-2)}`;
  return {
    name: 'Dashboard',
    model_id: Number(model.id),
    start_time:
      model?.time_properties?.time_granularity === 'M' ? fiscalStart : `Jan-${yr.slice(-2)}`,
    description: '',
  };
}

/** Suggested name when the user creates another pack on the same model. */
export function suggestNewDashboardName(existingNames: string[]): string {
  const base = 'Dashboard';
  if (!existingNames.some((n) => n.toLowerCase() === base.toLowerCase())) {
    return base;
  }
  for (let index = 2; index < 1000; index += 1) {
    const candidate = `${base} ${index}`;
    if (!existingNames.some((n) => n.toLowerCase() === candidate.toLowerCase())) {
      return candidate;
    }
  }
  return `${base} ${Date.now()}`;
}
